import { render, staticRenderFns } from "./GerenciarFaltasJustificadasPage.vue?vue&type=template&id=435f765a"
import script from "./GerenciarFaltasJustificadasPage.vue?vue&type=script&lang=js"
export * from "./GerenciarFaltasJustificadasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports